import { IAddressbook, IAddressBookListItem } from "../Interfaces/addressbook";
import { Packet } from "../Interfaces/commonDtos";
import { deleteRequest, getRequest, postRequest } from "./requestTemplates";

export const getAddressBooks = (): Promise<IAddressBookListItem[]> =>
  getRequest("/v1/AddressBook/AddressBooks");

export const deleteAddressBooks = (ids: number[]): Promise<Packet<boolean>> =>
  deleteRequest("/v1/AddressBook/AddressBook", ids);

export const addAddressbook = (dto: IAddressbook): Promise<Packet<boolean>> =>
  postRequest("/v1/AddressBook/AddressBook", dto);
